import { render, staticRenderFns } from "./moreML.vue?vue&type=template&id=0bb6ded2&lang=pug&"
import script from "./moreML.vue?vue&type=script&lang=js&"
export * from "./moreML.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports